import { notification } from 'antd';
import { fetchBuyerPointsFx, switchBuyerPointFx } from '../store/points.store';

export const switchBuyerPoint = async (id: number, enabled: 1 | 0) => {
  try {
    const res = await switchBuyerPointFx({ id, enabled });
    notification.success({
      message:
        enabled === 1
          ? 'Пункт приема зерна успешно включен'
          : 'Пункт приема зерна успешно отключен',
    });
    await fetchBuyerPointsFx();
    return res;
  } catch (err: any) {
    return notification.error({
      message: err.error || 'Непредвиденная ошибка. Попробуйте позже',
    });
  }
};
